import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { UpdateQuoteProductData } from "../types";

export const fetchUpdateQuoteProduct = (payload: UpdateQuoteProductData) => {
   return apiClient<ApiResponse>("/v1/quote/product", {
      method: "PUT",
      body: payload
   })
}
